(ns ui.fx.toast
  (:require
   [reagent.core :as r]
   [re-frame.core :as rf]
   ["react-hot-toast" :default toast :refer (Toaster)]))


(rf/reg-fx
 ::info
 (fn [{:keys [label opts]}]
   (let []
     (toast label (clj->js opts)))))


(rf/reg-fx
 ::custom
 (fn [{:keys [render-fn js-opts]}]
   (let [custom-toast-fn (aget toast "custom")]
     (.call custom-toast-fn toast render-fn js-opts))))

(rf/reg-fx
 ::success
 (fn [label opts]
   (let [success-fn (aget toast "success")]
     (.call success-fn toast label))))

(rf/reg-fx
 ::error
 (fn [label opts]
   (let [error-fn (aget toast "error")]
     (.call error-fn toast label))))

(rf/reg-fx
 ::dismiss
 (fn [toast-id]
   (let [dismiss-fn (aget toast "dismiss")]
     (.call dismiss-fn toast toast-id))))
